import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Box from '@mui/material/Box';
import { Typography, colors, Button } from '@leapeasy/ui-kit';

export default function AlertDialog(props) {
  const { open, handleClose, handleOk } = props;

  return (
    <div>
      <Dialog open={open} onClose={handleClose} className="rg-confirm-dialog">
        <DialogContent sx={{ padding: '24px 20px' }}>
          <DialogContentText>
            <Box
              display="flex"
              flexDirection="column"
              sx={{ gap: '10px', textAlign: 'center', color: colors.purple[900] }}
            >
              <Typography variant="body1" style={{ fontWeight: '600' }}>
                Please confirm you'd like to submit your application
              </Typography>

              <Typography variant="body2">
                Once submitted, we’ll conduct a preliminary screening based on information submitted
                in your application. We will follow up with you shortly to provide your screening
                results. If approved, additional documentation may be requested for verification
                purposes.
              </Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: '24px 20px', paddingTop: 0 }}>
          <Box
            className="rg-uikit-actions"
            display="flex"
            gap="12px"
            sx={{ padding: '0px 24px', width: '100%' }}
          >
            <Button onClick={handleClose} variant="secondary" size="medium">
              GO BACK
            </Button>
            <Button onClick={handleOk} variant="primary" size="medium">
              SUBMIT
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
